/**
 * @generated SignedSource<<c8da25cdf523d5e498857aa2ec8d1162>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorAvailabilityList_facility$data = {
  readonly club: {
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly id: string;
  readonly privateLessonsPermissionSet: {
    readonly bookingWindowDays: number | null | undefined;
    readonly patronSelectVenue: boolean | null | undefined;
  } | null | undefined;
  readonly publicLessonsPermissionSet: {
    readonly bookingWindowDays: number | null | undefined;
    readonly patronSelectVenue: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "InstructorAvailabilityList_facility";
};
export type InstructorAvailabilityList_facility$key = {
  readonly " $data"?: InstructorAvailabilityList_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorAvailabilityList_facility">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bookingWindowDays",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronSelectVenue",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorAvailabilityList_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "publicLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PrivateLessonsPermissionSet",
      "kind": "LinkedField",
      "name": "privateLessonsPermissionSet",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "9a6f4be3881bdfd78ed8b9ce43e907a4";

export default node;
